module.exports = __webpack_public_path__ + "images/af945c6d78221198290343d0cf744cbe-illu_newBox_ResolutionDoorWindowSensor.png";